<template>
  <div :class="props.type" />
</template>
<script setup lang="ts">
  const props = defineProps<{ type: 'lightToDark' | 'darkToLight' }>()
</script>
<style scoped lang="scss">
  .lightToDark {
    @include line(colors(light), colors(dark));
  }

  .darkToLight {
    @include line(colors(dark), colors(light));
  }
</style>
